export type Release = {
  version: string;
  channel: "dev" | "internal" | "private-preview" | "stable";
  status: "candidate" | "approved" | "withdrawn";
  updateType: "patch" | "minor" | "major" | "recovery";
  published: string;
  packageSize: string;
  signatureState: "fixture-not-installable" | "authenticode-verified";
};

export type Document = {
  category: string;
  title: string;
  summary: string;
  status: "Foundation" | "Owner input needed" | "App integration needed";
};

export const fixtureRelease: Release = {
  version: "0.0.0-dev.1",
  channel: "dev",
  status: "candidate",
  updateType: "patch",
  published: "Fixture generated locally",
  packageSize: "Not an installer",
  signatureState: "fixture-not-installable",
};

export const documents: Document[] = [
  {
    category: "Start",
    title: "Platform orientation",
    summary:
      "Understand the portal, local application boundary, release channels, and offline workflow.",
    status: "Foundation",
  },
  {
    category: "Install",
    title: "Windows installation",
    summary:
      "Reserved for verified requirements, installer behavior, prerequisites, and first launch.",
    status: "App integration needed",
  },
  {
    category: "Operate",
    title: "Connected and offline updates",
    summary:
      "How administrators review, verify, stage, install, and roll back approved releases.",
    status: "Foundation",
  },
  {
    category: "Investigate",
    title: "Evidence and investigation workflow",
    summary:
      "Reserved for product-verified capture, finding, evidence, and reporting procedures.",
    status: "App integration needed",
  },
  {
    category: "Administer",
    title: "Organizations and access",
    summary:
      "Invite users, assign roles, configure SSO, and review administrative events.",
    status: "Foundation",
  },
  {
    category: "Trust",
    title: "Security and data handling",
    summary:
      "Document local-data boundaries, signing, update verification, and support-data controls.",
    status: "Owner input needed",
  },
];
